// extracted by mini-css-extract-plugin
module.exports = {"plus":"plus-2h65h","minus":"minus-2P26d","disabled":"disabled-A30a5"};